import axios from 'axios'
import APIConfig from '../remote/APIConfig.js'
import Config from '@/assets/js/config.js'

export default class AuthService {
  constructor (passwordCrypter) {
    this.passwordCrypter = passwordCrypter
    this.apis = {
      login: payload => axios.post(APIConfig.BPIURL + '/login', payload),
      refresh: payload => axios.post(APIConfig.BPIURL + '/refresh', payload)
    }

    // fake data
    if (Config.useFakeData) {
      this.apis = {
        login: (payload) => new Promise((resolve, reject) => {
          console.log(`use fake data, login, payload=`, payload)
          var res = {
            data: {
              status: 'ok',
              result: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJRCI6MSwiSXNBZG1pbiI6dHJ1ZSwiZXhwIjo5OTE3OTc3NDkwLCJpc3MiOiJjb2R1cyIsIm5iZiI6MTU4NjQ0MTQ5MH0.g4CeU8AtZSmgKKfq5MYLu8aXOASo_u101yxaudCu3Es'
            }
          }
          resolve(res)
        })
      }
    }
  }

  getJWT () {
    return localStorage.getItem(Config.jwtStorageKey)
  }

  isJWTValid (jwt) {
    try {
      let jwtArr = jwt.split('.')
      let exp = JSON.parse(atob(jwtArr[1])).exp
      if (exp) return exp * 1000 > new Date().getTime()
    } catch (err) {
      console.error(err)
    }
    return false
  }

  saveJWT (jwt) {
    localStorage.setItem(Config.jwtStorageKey, jwt)
  }

  isLogined (vm) {
    let jwt = this.getJWT()
    if (!jwt) return false
    return this.isJWTValid(jwt)
  }

  logout (vm) {
    localStorage.removeItem(Config.jwtStorageKey)
  }

  login (vm, params) {
    vm.isLoading = true
    params.password = this.passwordCrypter.cryptPassword(params.password)
    return this.apis.login(params)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        if (ok) {
          let token = res.data.result
          this.saveJWT(token)
          axios.defaults.headers['Authorization'] = `Bearer ${token}`
        }
        return ok
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  refresh (vm) {
    // vm.isLoading = true
    let params = {}
    return this.apis.refresh(params)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let token = res.data.result
          this.saveJWT(token)
          axios.defaults.headers['Authorization'] = `Bearer ${token}`
          return res.data.result
        }
        if (res && res.data && res.data.error) throw res.data.error
        var msg = '未知的錯誤'
        throw msg
      })
  }
}
